import { render, staticRenderFns } from "./InvoiceList.vue?vue&type=template&id=23009e93&scoped=true&"
import script from "./InvoiceList.vue?vue&type=script&lang=ts&"
export * from "./InvoiceList.vue?vue&type=script&lang=ts&"
import style0 from "./InvoiceList.vue?vue&type=style&index=0&id=23009e93&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23009e93",
  null
  
)

export default component.exports